import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import {
  CleanIcon,
  TrashIcon,
  EditIcon,
  AddIcon,
  DownloadExcelIcon,
  ViewIcon,
  ToggleGreen,
  ToggleRed,
} from 'assets/icons';
import ModalCreate from './modal-create';
import { ModeratorService, UserService } from 'services';
import { TABS, TabsTop } from '../clients/clients';
import ModalView from '../modal-view';

declare var window: any;

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
};

class AdminModerators extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: ['Nombre', 'C.I.', 'Teléfono', 'Correo', 'Modulos autorizados', 'Estatus', 'Acciones'],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    visible: false,
    item: null,
    modules: [],
    visible_view: false,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Moderadores',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.loadModules();
    this.load();
  }

  loadModules = async () => {
    const res: any = await ModeratorService.admin.getModules({
      withoutLoading: true,
    });
    this.setState({
      modules: res.modules,
    });
  };

  load = async (withoutLoading: boolean = false) => {
    const res: any = await ModeratorService.admin.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
    });
    this.setState({
      data: res.moderators.rows,
      last_page: res.moderators.count,
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  edit = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible: true,
      item,
    });
  };

  delete = (e: any, item: any) => {
    e.preventDefault();
    Globals.confirm('¿Desea eliminar el moderador?', async () => {
      await ModeratorService.admin.delete({
        user_id: item.id,
      });
      this.load(true);
    });
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  add = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState(
      {
        visible: false,
        item: null,
      },
      () => this.load(true),
    );
  };

  download = async () => {
    const res: any = await ModeratorService.admin.download({
      ...this.state.form,
    });
    if (window.webkit && window.webkit.messageHandlers) {
      const message = 'open_url';
      const sendToNative = {
        message,
        url: Constants.BASE_STORAGE + res.url,
      };
      const stringifiedMessageObj = JSON.stringify(sendToNative);
      window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
    } else {
      Print(Constants.BASE_STORAGE + res.url);
    }
  };

  onCloseView = () => {
    this.setState({
      visible_view: false,
      item: null,
    });
  };

  view = (e: any, item: any) => {
    e.preventDefault();
    this.setState({
      visible_view: true,
      item,
    });
  };

  changeActive = (e: any, item: any) => {
    e.preventDefault();
    let message = '';
    let message_confirm = '';

    switch (item.status) {
      case Constants.USER_STATUS.ACTIVE:
        message = '¿Desea suspender el usuario?';
        message_confirm = 'Se ha suspendido el usuario';
        break;

      case Constants.USER_STATUS.INACTIVE:
        message = '¿Desea activar el usuario?';
        message_confirm = 'Se ha activado el usuario';
        break;
    }

    Globals.confirm(message, async () => {
      await UserService.admin.changeActive({
        user_id: item?.id,
      });
      this.load();
      Globals.showSuccess(message_confirm);
    });
  };

  render() {
    const { visible, visible_view } = this.state;

    return (
      <div id='admin-moderators'>
        <Modal
          className='modal-create-moderators'
          visible={visible}
          title={`${this.state.item ? 'Editar' : 'Crear'} moderador`}
          onClose={() => this.onClose()}
        >
          <ModalCreate
            modules={this.state.modules}
            item={this.state.item}
            onClose={() => this.onClose()}
          />
        </Modal>

        <Modal
          className='modal-view-user'
          visible={visible_view}
          title={''}
          onClose={() => this.onCloseView()}
        >
          <ModalView
            edit={() => {
              this.setState({
                visible_view: false,
                visible: true,
              });
            }}
            item={this.state.item}
            onClose={() => this.onCloseView()}
          />
        </Modal>

        <TabsTop history={this.props.history} active={TABS.MODERATORS} />

        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-5'>
                <Input
                  value={this.state.form.search}
                  name='search'
                  placeholder='Buscar'
                  label='Nombre, correo o cédula'
                  className='input-table'
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.change(e);
                  }}
                />
              </div>
              <div className='col-md-1'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title='Moderadores'
          data={this.state.data.length}
          header={this.state.header}
          rightAlign={[6]}
          titleRight={
            <>
              <div className='container-btns-table'>
                {this.state.data.length > 0 && (
                  <button className='btn download-excel' onClick={() => this.download()}>
                    <img src={DownloadExcelIcon} />
                    <p>Descargar Excel</p>
                  </button>
                )}
                {checkPermission(Constants.MODULES.USERS, 'write') && (
                  <div className='container-add-table' onClick={() => this.add()}>
                    <p>Nuevo</p>
                    <button className='btn add-btn-table'>
                      <img src={AddIcon} />
                    </button>
                  </div>
                )}
              </div>
            </>
          }
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>{i.full_name}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{i.full_document}</td>
                <td>{i.full_phone}</td>
                <td>{i.email}</td>
                <td>{i.status_text}</td>
                <td className='bold'>
                  {
                    i.module_permissions.filter((i: any) => {
                      return i.read || i.write || i.delete;
                    }).length
                  }{' '}
                  Autorizados
                </td>
                <td className='text-right'>
                  <Tooltip title='Ver'>
                    <a className='link-icon' href='#' onClick={(e: any) => this.view(e, i)}>
                      <img src={ViewIcon} />
                    </a>
                  </Tooltip>
                  {checkPermission(Constants.MODULES.USERS, 'write') && (
                    <Tooltip title='Editar'>
                      <a className='link-icon' href='#' onClick={(e: any) => this.edit(e, i)}>
                        <img src={EditIcon} />
                      </a>
                    </Tooltip>
                  )}
                  {checkPermission(Constants.MODULES.USERS, 'delete') && (
                    <Tooltip title='Eliminar'>
                      <a className='link-icon' href='#' onClick={(e: any) => this.delete(e, i)}>
                        <img src={TrashIcon} />
                      </a>
                    </Tooltip>
                  )}
                  {checkPermission(Constants.MODULES.USERS, 'write') && (
                    <Tooltip
                      title={i.status == Constants.USER_STATUS.ACTIVE ? 'Suspender' : 'Activar'}
                    >
                      <a
                        className='link-icon link-status'
                        href='#'
                        onClick={(e: any) => this.changeActive(e, i)}
                      >
                        <img
                          src={i.status == Constants.USER_STATUS.ACTIVE ? ToggleGreen : ToggleRed}
                        />
                      </a>
                    </Tooltip>
                  )}
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminModerators);
